import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import Cookies from '../utilities/Cookies';
import Component from '../site/Component';
import Analytics from './Analtyics';

/**
 * Component for Braze messaging and data collection
 */
export default class BrazeHachette extends Component {
  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    this.cookie = new Cookies();
    if (`next` === this.cookie.getCookie('cookie__privacy_policy')) {
      this.loadBrazeSdk();
      this.initializeBrazeSdk();
      this.onClickHandlers();
    }
    this.privacyPolicyOptInOut();
  }

  loadBrazeSdk(a = window, p = document, P = 'script', b, y) {
    a.braze = {}; a.brazeQueue = []; for (var s = "BrazeSdkMetadata DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Card.fromContentCardsJson ImageOnly CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount Feed Feed.prototype.getUnreadCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent InAppMessage.fromJson FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.addToSubscriptionGroup User.prototype.getUserId User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.removeFromCustomAttributeArray User.prototype.removeFromSubscriptionGroup User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent FeatureFlag FeatureFlag.prototype.getStringProperty FeatureFlag.prototype.getNumberProperty FeatureFlag.prototype.getBooleanProperty automaticallyShowInAppMessages destroyFeed hideContentCards showContentCards showFeed showInAppMessage deferInAppMessage toggleContentCards toggleFeed changeUser destroy getDeviceId getDeviceId initialize isPushBlocked isPushPermissionGranted isPushSupported logCardClick logCardDismissal logCardImpressions logContentCardImpressions logContentCardClick logCustomEvent logFeedDisplayed logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession requestPushPermission removeAllSubscriptions removeSubscription requestContentCardsRefresh requestFeedRefresh refreshFeatureFlags requestImmediateDataFlush enableSDK isDisabled setLogger setSdkAuthenticationSignature addSdkMetadata disableSDK subscribeToContentCardsUpdates subscribeToFeedUpdates subscribeToInAppMessage subscribeToSdkAuthenticationFailures toggleLogging unregisterPush wipeData handleBrazeAction subscribeToFeatureFlagsUpdates getAllFeatureFlags logFeatureFlagImpression".split(" "), i = 0; i < s.length; i++) { for (var m = s[i], k = a.braze, l = m.split("."), j = 0; j < l.length - 1; j++)k = k[l[j]]; k[l[j]] = (new Function("return function " + m.replace(/\./g, "_") + "(){window.brazeQueue.push(arguments); return true}"))() } window.braze.getDeferredInAppMessage = function () { return new window.braze.InAppMessage }; window.braze.getCachedContentCards = function () { return new window.braze.ContentCards }; window.braze.getCachedFeed = function () { return new window.braze.Feed }; window.braze.getUser = function () { return new window.braze.User }; window.braze.getFeatureFlag = function () { return new window.braze.FeatureFlag }; (y = p.createElement(P)).type = 'text/javascript';
    y.src = 'https://js.appboycdn.com/web-sdk/5.2/braze.min.js';
    y.async = 1; (b = p.getElementsByTagName(P)[0]).parentNode.insertBefore(y, b)
  }

  /**
 * initialize Braze SDK
 */
  initializeBrazeSdk() {
    const { hostname } = window.location;
    let brazeApiKey = '85922a94-e797-418e-b89f-67e0730ccde9';

    if (hostname != 'www.hachettebookgroup.com') {
      brazeApiKey = '122649f0-5c94-4339-bfd9-8693168b70fa';
    }
    braze.initialize(brazeApiKey, {
      baseUrl: "sdk.iad-05.braze.com",
      enableLogging: hostname != 'www.hachettebookgroup.com',
      allowUserSuppliedJavascript: true
    });
    // optionally show all in-app messages without custom handling
    braze.automaticallyShowInAppMessages();

    let brazeUserEmail = this.cookie.getCookie('brazeUser');
    if (brazeUserEmail !== '') {
      let md5 = function (d) { var r = M(V(Y(X(d), 8 * d.length))); return r.toLowerCase() }; function M(d) { for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++)_ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _); return f } function X(d) { for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++)_[m] = 0; for (m = 0; m < 8 * d.length; m += 8)_[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32; return _ } function V(d) { for (var _ = "", m = 0; m < 32 * d.length; m += 8)_ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255); return _ } function Y(d, _) { d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _; for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) { var h = m, t = f, g = r, e = i; f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e) } return Array(m, f, r, i) } function md5_cmn(d, _, m, f, r, i) { return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m) } function md5_ff(d, _, m, f, r, i, n) { return md5_cmn(_ & m | ~_ & f, d, _, r, i, n) } function md5_gg(d, _, m, f, r, i, n) { return md5_cmn(_ & f | m & ~f, d, _, r, i, n) } function md5_hh(d, _, m, f, r, i, n) { return md5_cmn(_ ^ m ^ f, d, _, r, i, n) } function md5_ii(d, _, m, f, r, i, n) { return md5_cmn(m ^ (_ | ~f), d, _, r, i, n) } function safe_add(d, _) { var m = (65535 & d) + (65535 & _); return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m } function bit_rol(d, _) { return d << _ | d >>> 32 - _ }
      let brazeUserId = md5(brazeUserEmail);
      braze.changeUser(brazeUserId);
    }

    const user = braze.getUser();

    let href = '';
    try {
      const url = new URL(window.location.href, window.location.origin); // normalize
      href = url.toString();
    } catch (e) {
      console.warn("Invalid URL blocked:", href);
      href = '';
    }

    let campaignData = this.getCampaignData(href);

    if (this.isAuthorPage()) {
      const authorData = this.getAuthorData();
      user.setCustomUserAttribute('Author', authorData);
      user.addToCustomAttributeArray('Authors', authorData);
      braze.logCustomEvent("Author", { author: authorData });
    }

    if (this.isGenerePage()) {
      const genreData = this.getGenreData();
      user.setCustomUserAttribute('LastGenrePage', genreData);
      user.addToCustomAttributeArray('GenrePages', genreData);
      braze.logCustomEvent("Genre", { genre: genreData });
    }

    if (this.isProductPage()) {
      const productData = this.getProductData();
      const authorData = this.getAuthorData();
      user.setCustomUserAttribute('Title', productData);
      user.addToCustomAttributeArray('Titles', productData);

      // Method 1: Get genres 2-4 from the Genre section specifically
      const genreSection = document.querySelector('.product-supplemental__taxonomies-genre');
      if (genreSection && genreSection.length) {
        const genreLinks = genreSection.querySelectorAll('.product-supplemental__taxonomies-list li a');
        const genres2to4 = Array.from(genreLinks).slice(1, 4).map(link => link.textContent.trim());
        for (let i = 0; i < genres2to4.length; i++) {
          user.addToCustomAttributeArray('GenrePages', genres2to4[i]);
        }
      }
      braze.logCustomEvent("Title", { title: `${productData} - ${authorData}` });
    }

    if (this.isISBNPage()) {
      const isbnData = this.getISBNData();
      try {
        braze.logCustomEvent("ISBN", { isbn: isbnData });
        user.addToCustomAttributeArray('ISBNs', isbnData);
        user.setCustomUserAttribute('ISBN', parseInt(isbnData));
      } catch (error) {
        console.error('ISBN is not a number', error);
      }
    }

    let hachetteJsonLinkingData = document.querySelector('#hachetteJsonLinkingData');
    if (hachetteJsonLinkingData) {
      let marketerData = JSON.parse(hachetteJsonLinkingData.innerText);

      //Product page load
      let sourceStr = '';
      setBrazeData(marketerData, campaignData, sourceStr);
    }

    braze.openSession();
  }


  /**
   * Get campaign params from URL
   * URL example: hachettebookgroup.com/contributor/author-name/?lens=example&utm_source=test1&utm_medium=test2&utm_campaign=test3&utm_content=test4&utm_term=test5#testanchor
   */
  getCampaignData(url) {
    var urlObj = new URL(url);
    return {
      name: urlObj.searchParams.get("utm_campaign"),
      source: urlObj.searchParams.get("utm_source"),
      medium: urlObj.searchParams.get("utm_medium"),
    };
  }

  /**
 * Privacy policy opt in and out
 */
  privacyPolicyOptInOut() {
    const optIn = document.querySelector('#privacyOptInOut #optIn');
    if (optIn) {
      optIn.addEventListener('click', () => {
        this.loadBrazeSdk();
        this.initializeBrazeSdk();
      });
    }
  }

  onClickHandlers() {
    const self = this; // Store reference to 'this' for use in event handlers

    document.querySelectorAll('a.title-formats-prices__item')?.forEach(item => {
      item.addEventListener('click', function (event) {
        const format = this.querySelector('.title-format-item');
        event.preventDefault();
        const href = item.href;

        const formatName = self.getFormatName(format);
        if (formatName) {
          braze.logCustomEvent("format_click", { format: formatName });
        }

        setTimeout(() => {
          try {
            const url = new URL(href, window.location.origin); // normalize
            // optional: restrict to same origin
            window.location.assign(url.toString());
          } catch (e) {
            console.warn("Invalid URL blocked:", href);
          }
        }, 200);
      });
    });

    document.querySelectorAll('a.title-buy-direct__button')?.forEach(item => {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        const href = item.href;

        const retailerName = self.getRetailerName(this);
        braze.logCustomEvent("retailer_clicked", { retailer: retailerName });

        setTimeout(() => {
          try {
            const url = new URL(href, window.location.origin); // normalize
            // optional: restrict to same origin
            window.location.assign(url.toString());
          } catch (e) {
            console.warn("Invalid URL blocked:", href);
          }
        }, 200);
      });
    });

    document.querySelectorAll('.title-add-to-cart__button')?.forEach(item => {
      item.addEventListener('click', function (event) {
        const productData = self.getProductData();
        const authorData = self.getTitleAuthorData();
        const isbnData = self.getISBNData();
        braze.logCustomEvent("add_to_cart_clicked", { title: productData, author: authorData, isbn: isbnData });
      });
    });

    document.querySelectorAll('ai-truncate[truncated=true] button')?.forEach(item => {
      item.addEventListener('click', function (event) {
        const productData = self.getProductData();
        const authorData = self.getTitleAuthorData();
        const isbnData = self.getISBNData();
        braze.logCustomEvent("continue_reading_clicked", { title: productData, author: authorData, isbn: isbnData });
      });
    });

    document.querySelectorAll('audio')?.forEach(item => {
      item.addEventListener("play", function (event) {
        const productData = self.getProductData();
        const authorData = self.getTitleAuthorData();
        const isbnData = self.getISBNData();
        braze.logCustomEvent("audio_excerpt_clicked", { title: productData, author: authorData, isbn: isbnData });
      });
    });
  }

  getFormatName(formatItem) {
    // Create a copy of the element so we don't modify the original
    const clone = formatItem.cloneNode(true);

    // Remove all price span elements from the copy
    clone.querySelectorAll('.title-format-item__price').forEach(price => {
      price.remove();
    });

    // Return the cleaned text content
    return clone.textContent.trim();
  }
  getRetailerName(retailerItem) {
    // Create a copy of the element so we don't modify the original
    const clone = retailerItem.cloneNode(true);

    // Return the cleaned text content
    return clone.textContent.trim();
  }

  isAuthorPage() {
    return document.querySelector('h1.meet-the-author__title') && document.querySelector('body.single-contributor')
  }

  getAuthorData() {
    return document.querySelector('h1.meet-the-author__title')?.innerText;
  }
  getTitleAuthorData() {
    const authorLink = document.querySelector('.product-details__contributors .product-details__contributor-link');
    return authorLink ? authorLink.textContent.trim() : null;
  }

  isGenerePage() {
    return document.querySelector('h1.genre-details_title')
  }

  getGenreData() {
    return document.querySelector('h1.genre-details_title')?.innerText;
  }

  isProductPage() {
    return document.querySelector('h1.product-details__title')
  }

  getProductData() {
    return document.querySelector('h1.product-details__title')?.innerText;
  }

  isISBNPage() {
    const isbn13Element = document.evaluate(
      "//div[contains(@class, 'product-supplemental__details__group')][.//dt[contains(@class, 'product-supplemental__details__term') and normalize-space(text())='ISBN-13']]//dd[contains(@class, 'product-supplemental__details__def')]",
      document,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    ).singleNodeValue;

    return isbn13Element !== null;
  }

  getISBNData() {
    const isbn13Element = document.evaluate(
      "//div[contains(@class, 'product-supplemental__details__group')][.//dt[contains(@class, 'product-supplemental__details__term') and normalize-space(text())='ISBN-13']]//dd[contains(@class, 'product-supplemental__details__def')]",
      document,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    ).singleNodeValue;

    const isbn13Value = isbn13Element ? isbn13Element.textContent.trim() : null;
    return isbn13Value;
  }
}

function setBrazeData(marketerData = {}, campaignData = {}, sourceStr = '') {
  if (marketerData.isbn !== undefined) {
    setBrazeArrayCustomAttr('ISBNs', marketerData.isbn, sourceStr);
  }
  if (marketerData.name !== undefined) {
    setBrazeArrayCustomAttr('Referral Titles', marketerData.name, sourceStr);
  }
  if (marketerData.author !== undefined) {
    setBrazeArrayCustomAttr('Referral Authors', marketerData.author, sourceStr, true);
  }
  if (marketerData.singleAuthor !== undefined) {
    setBrazeArrayCustomAttr('Referral Authors', marketerData.singleAuthor, sourceStr);
  }
  if (marketerData.bookFormat !== undefined && marketerData.bookFormat.name) {
    setBrazeArrayCustomAttr('Product Formats', marketerData.bookFormat.name, sourceStr);
  }
  if (marketerData.series !== undefined) {
    setBrazeArrayCustomAttr('Series Name', marketerData.series, sourceStr);
  }
  if (marketerData.publisher !== undefined && marketerData.publisher.name !== undefined) {
    setBrazeArrayCustomAttr('Publisher', marketerData.publisher.name, sourceStr);
  }
  if (campaignData.name !== undefined) {
    setBrazeArrayCustomAttr('Campaign Name', campaignData.name, sourceStr);
  }
  if (campaignData.source !== undefined) {
    setBrazeArrayCustomAttr('Campaign Sources', campaignData.source, sourceStr);
  }
  if (campaignData.medium !== undefined) {
    setBrazeArrayCustomAttr('Campaign Media', campaignData.medium, sourceStr);
  }
  if (marketerData.genre !== undefined) {
    setBrazeArrayCustomAttr('Genre', marketerData.genre, sourceStr, true, true);
  }
}

/**
   * Set Braze custom attributes of array 100
   */
function setBrazeArrayCustomAttr(attrName, attrVal, sourceStr, isAttrValArray = false, allLower = false) {
  if (isAttrValArray) {
    for (let i = 0; i < attrVal.length; i++) {
      setBrazeSingleElemArrayCustomAttr(attrName, attrVal[i], sourceStr, allLower);
    }
  } else {
    setBrazeSingleElemArrayCustomAttr(attrName, attrVal, sourceStr, allLower);
  }
}

/**
 * Set a single elem value of a Braze custom attribute of array 100
 */
function setBrazeSingleElemArrayCustomAttr(attrName, attrVal, sourceStr, allLower = false) {
  if (attrVal) {
    braze.getUser().addToCustomAttributeArray(
      attrName,
      allLower ? attrVal.toLowerCase() + sourceStr : attrVal + sourceStr
    );
  }
}